'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body className="bg-surface-page">
        <div className="flex min-h-screen flex-col items-center justify-center px-8 text-center">
          <h2 className="font-heading text-page-title text-text-heading">Something went wrong</h2>
          <p className="mb-6 mt-2 max-w-md font-body text-body-sm text-text-muted">
            An unexpected error occurred. Please try again.
          </p>
          <button
            onClick={reset}
            className="rounded-lg bg-statura-green-accessible px-6 py-2.5 font-body text-body-sm font-semibold text-white transition-interactive duration-200 hover:bg-statura-green-accessible-hover"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
